import React, { useState, useEffect } from "react";
import "react-multi-carousel/lib/styles.css";
import BoatHelm from "../../../../../../Asset/icon/boat_helm.svg";
import TopDestinationMultiRow from "../../../../../../components/multiRow/TopDestinationMultiRow";
import AllHeader from "../../../../../../components/Navbar/AllHeader";
import Footer from "../../../../../../components/footerPage/Footer";
import ProvinceCard from "../../../../../../components/card/ProvinceCard";
import { useTranslation } from "react-i18next";
import Sail from "../../../../../../Asset/image/yacht/Sail.gif";
import { useParams } from "react-router-dom";
import SEO from "../../../../../../components/SEO/SEO";
import { useSelector, useDispatch } from "react-redux";
import {
  getProvinceDetail,
  getProvinceDescriptionDetail,
} from "../../../../../../redux/centerData/CenterDataSlice";

function DetailProvince() {
  const { t } = useTranslation();
  const { slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const todos = useSelector((state) => state);
  const dispatch = useDispatch();
  const selectedLanguage = localStorage.getItem("selectedLanguage");

  useEffect(() => {
    // Fetch data from the API

    Promise.all([
      dispatch(getProvinceDetail({})),
      dispatch(getProvinceDescriptionDetail({})),
    ])
      .then(() => {
        // Data loading is complete, set loading state to false
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        // Handle error if needed
      });
  }, [dispatch]);

  const province = todos?.CenterDataSlice?.Province?.results?.find(
    (item) => item.ProvinceEng?.toLowerCase() === slug?.toLowerCase(),
  );

  const provinceDescription =
    todos?.CenterDataSlice?.ProvinceDescription?.results?.find(
      (item) => item.id_province === province?.ProvinceID,
    );

  const seoDescription =
    provinceDescription?.description_en ||
    `Discover premium yacht charter services in ${slug}, Thailand. Enjoy private charters with professional crew and tailor-made cruising routes.`;

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    // จำลองโหลดข้อมูล
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const provinceName =
    selectedLanguage === "th"
      ? province?.ProvinceThai || slug
      : province?.ProvinceEng || slug;

  return (
    <>
      {!loading && (
        <SEO
          title={
            selectedLanguage === "en"
              ? `Yacht Charter in ${provinceName} | Take My Yacht`
              : `เช่าเรือยอชต์ที่ ${provinceName} | Take My Yacht`
          }
          description={
            selectedLanguage === "en"
              ? seoDescription
              : `บริการเช่าเรือยอชต์ระดับพรีเมียมใน${provinceName} ประเทศไทย`
          }
          url={`https://takemyyacht.com/destination/detailProvince/${slug}`}
          schema={{
            "@context": "https://schema.org",
            "@type": "Place",
            name:
              selectedLanguage === "en"
                ? `Yacht Charter in ${provinceName}`
                : `เช่าเรือยอชต์ที่ ${provinceName}`,
            description:
              selectedLanguage === "en"
                ? `Premium yacht charter services available in ${provinceName}, Thailand.`
                : `บริการเช่าเรือยอชต์ระดับพรีเมียมใน${provinceName} ประเทศไทย`,
            address: {
              "@type": "PostalAddress",
              addressRegion: provinceName,
              addressCountry: "TH",
            },
          }}
        />
      )}

      {loading && (
        <div
          className="overlay"
        >
          <img
            src={Sail}
            alt="Loading..."
            className="img-box"
            draggable={false}
          />
        </div>
      )}

      <div>
        <AllHeader />
        <div className="container mt-5vh">
          <div className="row align-items-stretch">
            {/* ช่องว่างซ้าย (เฉพาะจอใหญ่) */}
            <div className="col-lg-1 d-none d-lg-block"></div>
            {/* Top Destinations */}
            <div className="col-lg-4 col-md-12 mb-4 text-center">
              <TopDestinationMultiRow />
            </div>

            {/* ช่องว่างกลาง (เฉพาะจอใหญ่) */}
            <div className="col-lg-1 d-none d-lg-block"></div>

            {/* Provinces */}
            <div className="col-lg-5 col-md-12 mb-4 text-center">
              <div className="mb-4">
                <img
                  className="BoatHelm-1"
                  draggable={false}
                  src={BoatHelm}
                  alt="BoatHelm"
                />
                <h3>{t("Provinces")}</h3>
              </div>
              <ProvinceCard />
            </div>

            {/* ช่องว่างขวา (เฉพาะจอใหญ่) */}
            <div className="col-lg-1 d-none d-lg-block"></div>
          </div>
        </div>
        <Footer />
      </div>

      {showScrollTop && (
        <button
          onClick={scrollToTop}
          aria-label="Scroll to top"
          className="fab-button"
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-4px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          {/* Chevron Up */}
          <svg
            width="26"
            height="26"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="18 15 12 9 6 15" />
          </svg>
        </button>
      )}
    </>
  );
}

export default DetailProvince;
